const { values } = require("lodash");

$(document).ready(function() {

    $('[data-toggle="tooltip"]').tooltip();

    // Build product add to basket url, with combination products
    $('input.combination').on('change', function (e) {

        if ($(this).is(':checked')) {
            let selectedValue = $(this).val();
            $("input[name=combination_id]").val(selectedValue);

            $('input.combination').each(function () {
                if ($(this).is(':checked') && $(this).val() != selectedValue) {
                    $(this).prop( "checked", false );
                }
            });

            // Check if the product is out of stock and needs to be on backorder.
            if ($(this).data('backorder') == 'TRUE') {
                $("input[name=combination_backorder]").val("True");
            }

            // Get the Total
            var current_total = parseFloat($('#product_price').val().replace(',', '')) + parseFloat($(this).data('price'));

            current_total = current_total.toFixed(2);

            // Add total price to the page.
            $('#total_price').text(current_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));

        } else {
            $("input[name=combination_id]").val("");
            $("input[name=combination_backorder]").val("");
            $('#total_price').text($('#product_price').val());
        }
    });
});
